import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
})
export class ErrorPopupComponent {
  show_Dialog: boolean = false;
  title: string = 'Error';
  message: string = '';

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  show(message: string, title?: string) {
    this.title = title || 'Error';
    this.message = message || 'Something went wrong.';
    this.show_Dialog = true;
  }

  hide() {
    this.show_Dialog = false;
  }
}


